export class  CloudProvider{
  providerName: string;
  providerValue: string;
  providerIconFileName: string;
  providerSubTitle: string;
  providerDescription: string;
  providerJsonFile: string;
  providerDeploymentType: string;
  providerUseStaticForm: boolean = false;

  constructor(name: string, value: string, iconFileName: string, subTitle: string, 
    description: string, jsonFile: string, deploymentType: string, useStaticForm: boolean = false) {
    this.providerName = name
    this.providerValue = value
    this.providerIconFileName = iconFileName
    this.providerSubTitle = subTitle
    this.providerDescription = description
    this.providerJsonFile = jsonFile
    this.providerDeploymentType = deploymentType
    this.providerUseStaticForm = useStaticForm
  }
}
